import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {FedexFileState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class FedexFileQuery extends QueryEntity<FedexFileState> {

  constructor(protected store: Store) {
    super(store);
  }

}
